import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import Clear from "@mui/icons-material/Clear";
import { withTranslation } from "react-i18next";
import React from "react";
import styles from "./ShowInventoryData.module.scss";
import LoadDealerPricing from "./LoadDealerPricing";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import commonFordStyles from "../../../../styles/common/CommonStyles.module.scss";
import commonLincolnStyles from "../../../../styles/common/CommonStyles-Lincoln.module.scss";
import { IS_FORD_BRAND } from "../../../../utils/EmpUtil";

const StyledDialog = styled(Dialog)({
  root: {
    flexGrow: 1,
    marginTop: 20,
  },
});

const ShowInventoryData = (props) => {
  const isFordBrand = IS_FORD_BRAND(props.user && props.user.brand);
  const commonStyles = isFordBrand ? commonFordStyles : commonLincolnStyles;

  return (
    <StyledDialog
      open={props.open}
      className={styles.dialog}
      onClose={props.onClose}
      fullWidth={true}
      maxWidth="lg"
    >
      <Grid container id="deleteDialog" data-testid="confirmSaveSettings">
        <div className={styles.wrapper}>
          <button className={styles.close} onClick={props.closeModal}>
            <Clear />
          </button>
          <LoadDealerPricing
            {...props}
            showValidatdColumn={false}
            isMEXMarket={props.isMEXMarket}
          />
          <div className={styles.root}>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <div className={styles.buttonContainer}>
                  <Button
                    className={commonStyles.cancelledDialogButton}
                    id="cancelDialog"
                    data-testid="closeDialog"
                    onClick={props.closeModal}
                  >
                    {props.t("UploadDealerPrice.btnCancel")}
                  </Button>
                </div>
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <div className={styles.buttonContainer}>
                  <Button
                    className={commonStyles.confirmDialogButton}
                    id="confirmDialog"
                    data-testid="confirmDialog"
                    onClick={props.uploadDealerPriceToSave}
                  >
                    {props.t("UploadDealerPrice.btnSubmit")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Grid>
    </StyledDialog>
  );
};

export default withTranslation("emp")(ShowInventoryData);
